function stripHtmlAndLimitWords(htmlString, wordLimit = 0) {
  if (!htmlString) return "";
  const text = htmlString.replace(/<[^>]*>/g, " ");

  const cleanText = text.replace(/\s+/g, " ").trim();
  const words = cleanText.split(" ");
  if(wordLimit){
    const limited = words.slice(0, wordLimit).join(" ");
    return limited;
  }
  return cleanText;
}
function SearchProductCard(item, html, components) {
  const priceHtml = Itemprice(item, html);
    let variantTitle = item.variant_title == "Default Title" ? "" : item.variant_title;
    return html`<a href="${algoliaShopify.helpers.instantsearchLink(item)}" class="aa-ItemLink aa-ProductItem">
            <div class="aa-ItemContent">
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                    <img src="${item.image ? algoliaShopify.helpers.mediumImage(item) : window.fallbackImage}" alt="${item.title}" style="" width="50" height="50" />
                </div>
                <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentBrand">${item.vendor}</div>
                    <div class="aa-ItemContentTitleWrapper">
                        <div class="aa-ItemContentTitle">${components.Highlight({
                            hit: item,
                            attribute: "title"
                        })}</div>
                        <div class="aa-ItemContentVariant">${variantTitle}</div>
                    </div>
                    <div class="aa-ItemContentPrice aa-inline-cart">
                        <div class="aa-ItemContentPriceCurrent">${priceHtml}</div>
                    </div>
                </div>
            </div>
        </a>`
}
function RenderProductCard(item,html,components) {
    const priceHtml = Itemprice(item, html);
    var CTAButton= '';
    if(item.inventory_available == false){
        CTAButton = html`<button type="submit" name="add" class="product-form__submit button button--full-width button--red-primary" aria-haspopup="dialog" aria-live="polite" disabled>
                <span class="sold-out-message"> Sold out </span>
                </button>`
    }else{
        CTAButton = html`<button type="submit" name="add" class="product-form__submit button button--full-width button--red-primary" aria-haspopup="dialog" aria-live="polite">
                <span>Add to Cart </span>
                <div class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                    </svg>
                </div>
                </button>`
    }
    // if(item.variants_count != 1){
    //     CTAButton = html`<a href="${algoliaShopify.helpers.instantsearchLink(item)}" class="button button--full-width button--red-secondary">
    //                     <span>View Options</span>
    //                 </a>`;
    // }
  let variantTitle = item.variant_title == "Default Title" ? "" : item.variant_title;
  let ratinghtml = "";
  if(item.meta?.yotpo?.reviews_count){
      let reviewText = item.meta.yotpo.reviews_count > 1 ? "reviews" : "review";
      ratinghtml = html`<div class="yotpo bottomLine review-custom-yotpo"
                      data-appkey="JnX0bX7DYZ65KTkQ2iEhPrCse0Ub62wGfWywmC3H"
                      data-domain="${window.shop_permanent_domain}"
                      data-product-id="${item.id}"
                      data-product-models="${item.id}"
                      data-name="${item.title.replace(/'/g, "\\'").replace(/"/g, "&quot;")}"
                      data-url="${window.location.href}"
                      data-image-url="${item.featured_image ? algoliaShopify.helpers.largeImage(item) : window.fallbackImage}"
                      data-bread-crumbs="${item.tags.map(tag => tag.replace(/'/g, "\\'").replace(/"/g, "&quot;")).join(';')}"></div>`;
  }
  var collection_url = "";
  if(window.current_collection){
      collection_url = `/collections/${window.current_collection}`;
  }
return html`<div class="card-wrapper product-card-wrapper">
    <div class=" card card--standard card--media">
        <div class="card__inner color-scheme-2 gradient ratio">
            <a href="${collection_url}${algoliaShopify.helpers.instantsearchLink(item)}" class="card__media">
                <div class="media media--transparent media--hover-effect">
                <img src="${item.product_image ? algoliaShopify.helpers.mediumImage(item) : window.fallbackImage}" alt="${item.title.replace(/'/g, "\\'").replace(/"/g, "&quot;")}" data-product-title="${item.title.replace(/'/g, "\\'").replace(/"/g, "&quot;")}" class="motion-reduce ls-is-cached lazyloaded" width="auto" height="auto" />
                </div>
            </a>
        </div>

        <div class="card__content">
            <div class="card__information">
                <div class="card__heading --h5">
                <a href="${collection_url}${algoliaShopify.helpers.instantsearchLink(item)}" class="full-unstyled-link" aria-labelledby="">
                ${item.title}
                </a>
                <div class="card__heading_variant">${variantTitle}</div>
                </div>
            </div>
        </div>
        ${ratinghtml}
        <div class="card-information">
        ${priceHtml}
            <product-form class="test-form">
                <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product" />
                    <input type="hidden" name="utf8" value="✓" />
                    <input type="hidden" name="id" value="${item.objectID}" class="product-variant-id" />
                    ${CTAButton}
                    <input type="hidden" name="product-id" value="${item.id}" />
                </form>
            </product-form>
        </div>

    </div>
</div>`
}
function Itemprice(item, html){
    var Discountedprice = '';
    var priceHtml = "";
    var discountPer;
    var compare_price = item.compare_at_price;
    // if(item.variants_count == 1){
        if(item.compare_at_price > item.price){
            Discountedprice = item.price;
            discountPer = parseInt(((item.compare_at_price - item.price) * 100) / item.compare_at_price);
        }
        if(window.CustomerGroup == 'CG_Shelter'){
            if(item.meta?.custom.hasOwnProperty('shelter_price') &&  item.meta?.custom?.shelter_price != ""){
                Discountedprice = item.meta?.custom?.shelter_price;
                discountPer = parseInt(((item.price - Discountedprice) * 100) / item.price);
                compare_price = item.price;
            }
        }
        if(window.CustomerGroup == 'CG_Employee'){
            if(item.meta?.custom.hasOwnProperty('employee_price') && item.meta?.custom?.employee_price != ""){
              Discountedprice = item.meta?.custom?.employee_price;
              discountPer = parseInt(((item.price - Discountedprice) * 100) / item.price);
              compare_price = item.price;
            }
        }
    // }
    if(Discountedprice && Discountedprice != ''){
        priceHtml =html`
        <div class="price predictive-search__item-product-price price--on-sale">
                <div class="price__container">
                <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular h3">
                    ${algoliaShopify.formatMoney(Discountedprice * 100)}
                    </span>
                </div>
                <div class="price__sale">
                    <span class="price-item price-item--sale price-item--last h3">
                    ${algoliaShopify.formatMoney(Discountedprice * 100)}
                    </span>
                    <span class="price-item price-item--regular">
                    ${algoliaShopify.formatMoney(compare_price * 100)}
                    </span>
                    <span class="price-discount-value">(${discountPer}% off)</span>
                </div>
                </div>
        </div>`
    }else{
      priceHtml =html`
            <div class="price predictive-search__item-product-price">
              <div class="price__container">
                <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular h3">
                    ${algoliaShopify.formatMoney(item.price*100)}
                    </span>
                </div>
                <div class="price__sale">
                    <span class="price-item price-item--sale price-item--last h3"></span>
                    <span class="price-item price-item--regular"></span>
                    <span class="price-discount-value"></span>
                </div>
              </div>
            </div>`
        // return algoliaShopify.helpers.displayPrice(item,true);
    }
    return priceHtml;
}

function getIndexNameWithPrefix(indexSuffix) {
  const prefix = window.algoliaShopify?.config?.index_prefix || '';
  return `${prefix}${indexSuffix}`;
}

function ensureSupplementarySearchContainers() {
  const productsContainer = document.querySelector('.ais-results-as-block');
  if (!productsContainer) return null;

  let wrapper = document.querySelector('.ais-extra-results');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'ais-extra-results';
    productsContainer.insertAdjacentElement('afterend', wrapper);
  }

  // let collectionsSection = wrapper.querySelector('.ais-extra-results__section--collections');
  // if (!collectionsSection) {
  //   collectionsSection = document.createElement('section');
  //   collectionsSection.className = 'ais-extra-results__section ais-extra-results__section--collections';
  //   collectionsSection.style.display = 'none';
  //   collectionsSection.innerHTML = '<h3 class="ais-extra-results__title">Collections</h3><div class="ais-extra-results__hits ais-extra-results__hits--collections"></div>';
  //   wrapper.appendChild(collectionsSection);
  // }

  let articlesSection = wrapper.querySelector('.ais-extra-results__section--articles');
  if (!articlesSection) {
    articlesSection = document.createElement('section');
    articlesSection.className = 'ais-extra-results__section ais-extra-results__section--articles';
    articlesSection.style.display = 'none';
    articlesSection.innerHTML = '<h3 class="ais-extra-results__title">Articles & Blogs</h3><div class="ais-extra-results__hits ais-extra-results__hits--articles"></div>';
    wrapper.appendChild(articlesSection);
  }

  // let pagesSection = wrapper.querySelector('.ais-extra-results__section--pages');
  // if (!pagesSection) {
  //   pagesSection = document.createElement('section');
  //   pagesSection.className = 'ais-extra-results__section ais-extra-results__section--pages';
  //   pagesSection.style.display = 'none';
  //   pagesSection.innerHTML = '<h3 class="ais-extra-results__title">Pages</h3><div class="ais-extra-results__hits ais-extra-results__hits--pages"></div>';
  //   wrapper.appendChild(pagesSection);
  // }

  return {
    // collectionsSection,
    articlesSection,
    // pagesSection,
    // collectionsContainer: '.ais-extra-results__hits--collections',
    articlesContainer: '.ais-extra-results__hits--articles',
    // pagesContainer: '.ais-extra-results__hits--pages',
  };
}

document.addEventListener("algolia.instantSearch.onRender", function() {
    document.querySelectorAll('.ais-InfiniteHits-item product-form').forEach((el) => {
      el.initialize();
    });
});
document.addEventListener("algolia.hooks.initialize", function() {
    var promo_card_wrapper = document.querySelector('.promo-card-wrapper');
    var promo_pos = -1;
    if(promo_card_wrapper){
        promo_pos = promo_card_wrapper.getAttribute('data-position') - 1;
    }
    algoliaShopify.hooks.registerHook("afterInstantSearchStartRemoveDefaultWidgets", (defaultWidgets) => {
			const defaultHits = defaultWidgets.find(
				(widget) => (widget.$$widgetType === "ais.hits"),
			);
            const defaultPaginationWidget = defaultWidgets.find(
				(widget) => (widget.$$widgetType === "ais.pagination"),
			);
			return [defaultHits, defaultPaginationWidget];
		},
	),
    algoliaShopify.hooks.registerHook("beforeInstantSearchStartAddWidgets", () => {
      const { infiniteHits, index, configure } = window.instantsearch.widgets;

      const infiniteHitsWidget = infiniteHits({
        container: ".ais-results-as-block",
        transformItems(items) {
            return items.flatMap((item) => {
            const result = [{ ...item }];
            if (item.__position == promo_pos) {
              result.push({
                title: 'custom-promo-card',
                className: "custom-promo-card"
              });
            }
            return result;
          });
        },
        templates: {
            item(item, {html, components}) {
              requestAnimationFrame(() => {
                  const items = document.querySelectorAll(
                    '.ais-results-as-block .ais-InfiniteHits-item'
                  );
                  if(item.title === 'custom-promo-card') {
                    items[promo_pos]?.classList.add('custom-promo-card');
                  }
                });

              if(item.title === 'custom-promo-card') {
                return document.querySelector('.promo-card-wrapper')?.innerHTML || '';
              }else{

              }
                return html`${RenderProductCard(item, html, components)}`
            },
            empty: ({query: t}, {html}) => {
                document.getElementById('algolia-shopify-instantsearch').classList.add("no-results");
                return html`<h2 class="title title--primary">No products found</h2>`
            },
            showMoreText(data, { html }) {
                return html`Load more`;
            },
        }
      });

      if (window.location.pathname !== '/search') {
        return [infiniteHitsWidget];
      }

      const extraContainers = ensureSupplementarySearchContainers();
      if (!extraContainers) {
        return [infiniteHitsWidget];
      }

      // const collectionsIndexWidget = index({
      //   indexName: getIndexNameWithPrefix('collections'),
      //   indexId: 'collections-index',
      // });

      // collectionsIndexWidget.addWidgets([
      //   configure({ hitsPerPage: 4 }),
      //   infiniteHits({
      //     container: extraContainers.collectionsContainer,
      //     transformItems(items) {
      //       extraContainers.collectionsSection.style.display = items.length ? '' : 'none';
      //       return items;
      //     },
      //     templates: {
      //       item(item, { html, components }) {
      //         const collectionUrl = item.url || `/collections/${item.handle}`;
      //         return html`<a href="${collectionUrl}" class="ais-extra-results__item-link">${components.Highlight({ hit: item, attribute: 'title' })}</a>`;
      //       },
      //       showMoreText(data, { html }) {
      //         return html`Load more collections`;
      //       },
      //       empty() {
      //         return '';
      //       },
      //     },
      //   }),
      // ]);

      const articlesIndexWidget = index({
        indexName: getIndexNameWithPrefix('articles'),
        indexId: 'articles-index',
      });

      articlesIndexWidget.addWidgets([
        configure({ hitsPerPage: 4 }),
        infiniteHits({
          container: extraContainers.articlesContainer,
          transformItems(items) {
            extraContainers.articlesSection.style.display = items.length ? '' : 'none';
            return items;
          },
          templates: {
            item(item, { html, components }) {
              const articleUrl = item.url || `/blogs/${item.blog?.handle}/${item.handle}`;
              var title = new DOMParser().parseFromString(item.title, "text/html").documentElement.textContent;
              return html`<div class="article-card-vertical">
                <div class="article-card-vertical__image-wrapper">
                  <figure class="article-card-vertical__image">
                    <img src="${item.image ? algoliaShopify.helpers.mediumImage(item) : window.fallbackImage}" alt="${title}" width="auto" height="auto" />
                  </figure>
                </div>
                <div class="article-card-vertical__content">
                  <span class="article-card__category">${item.tags[0]}</span>
                  <h3 class="article-card-vertical__title">${title}</h3>
                  <div class="article-card-vertical__excerpt">${stripHtmlAndLimitWords(item.body_html_safe,30)}</div>
                  <div class="article-card-vertical__footer">
                  <a href="${articleUrl}" class="article-card-vertical__link">
                  Read More
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.7143 2.16073L10.0893 6.53573C10.1505 6.59669 10.199 6.66914 10.2321 6.74891C10.2653 6.82868 10.2823 6.9142 10.2823 7.00057C10.2823 7.08694 10.2653 7.17246 10.2321 7.25223C10.199 7.332 10.1505 7.40445 10.0893 7.46541L5.7143 11.8404C5.59102 11.9637 5.42381 12.033 5.24946 12.033C5.07511 12.033 4.9079 11.9637 4.78461 11.8404C4.66133 11.7171 4.59207 11.5499 4.59207 11.3756C4.59207 11.2012 4.66133 11.034 4.78461 10.9107L8.69532 7.00002L4.78407 3.08932C4.66078 2.96604 4.59152 2.79883 4.59152 2.62448C4.59152 2.45013 4.66078 2.28292 4.78407 2.15963C4.90735 2.03635 5.07456 1.96709 5.24891 1.96709C5.42326 1.96709 5.59047 2.03635 5.71375 2.15963L5.7143 2.16073Z" fill="#1A3673"></path>
                      </svg>
                    </a>
                  </div>
                </div>  
              </div>`
              return html`<a href="${articleUrl}" class="ais-extra-results__item-link">${components.Highlight({ hit: item, attribute: 'title' })}</a>`;
            },
            showMoreText(data, { html }) {
              return html`Load more`;
            },
            empty() {
              return '';
            },
          },
        }),
      ]);

      // const pagesIndexWidget = index({
      //   indexName: getIndexNameWithPrefix('pages'),
      //   indexId: 'pages-index',
      // });

      // pagesIndexWidget.addWidgets([
      //   configure({ hitsPerPage: 4 }),
      //   infiniteHits({
      //     container: extraContainers.pagesContainer,
      //     transformItems(items) {
      //       extraContainers.pagesSection.style.display = items.length ? '' : 'none';
      //       return items;
      //     },
      //     templates: {
      //       item(item, { html, components }) {
      //         const pageUrl = item.url || `/pages/${item.handle}`;
      //         return html`<a href="${pageUrl}" class="ais-extra-results__item-link">${components.Highlight({ hit: item, attribute: 'title' })}</a>`;
      //       },
      //       showMoreText(data, { html }) {
      //         return html`Load more pages`;
      //       },
      //       empty() {
      //         return '';
      //       },
      //     },
      //   }),
      // ]);

      // return [infiniteHitsWidget, collectionsIndexWidget, articlesIndexWidget, pagesIndexWidget];
      return [infiniteHitsWidget,  articlesIndexWidget];
    }
    ),
    algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function(options) {
        options.placeholder = 'Search by product, SKU or animal';
        let autocompleteApi = null;
        return options.onStateChange = function({state, setIsOpen}) {
            autocompleteApi = {
                state,
                setIsOpen
            }
        },options
    }),
    algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", function(_defaultTemplate, templateOptions, distinct, itemLink) {
        const {html, item, components} = templateOptions;
        return SearchProductCard(item,html,components);
    })
});
(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     CONFIG
  ───────────────────────────────────────────── */
  const CONFIG = {
    appId:   'NYG9OLHWJB',
    apiKey:  '0bfe0ccf35bbfad386e3592cb496f44e',
    indices: {
      products:    'shopify_products',
      articles:    'shopify_articles',
      collections: 'shopify_collections',
      pages: 'shopify_pages',
    },
    hitsPerSource: {
      products:    3,
      articles:    2,
      collections: 2,
      pages: 2,
    },
    container:     '.header__search--mobile form',
    searchPageUrl: '/search'
  };

  /* ─────────────────────────────────────────────
     WAIT FOR LIBRARIES
  ───────────────────────────────────────────── */
  function waitForLibraries(callback) {
    const maxWait = 5000;
    const interval = 100;
    let elapsed = 0;

    const check = setInterval(() => {
      if (window.algoliasearch && window['@algolia/autocomplete-js']) {
        clearInterval(check);
        callback();
      } else {
        elapsed += interval;
        if (elapsed >= maxWait) {
          clearInterval(check);
          console.warn('[Algolia Mobile] Libraries not loaded after 5s.');
        }
      }
    }, interval);
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  function initMobileAutocomplete() {
    const container = document.querySelector(CONFIG.container);
    if (!container) {
      console.warn('[Algolia Mobile] Container not found:', CONFIG.container);
      return;
    }

    const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
    const searchClient = algoliasearch(CONFIG.appId, CONFIG.apiKey);

    autocomplete({
      container,
      placeholder: 'Search by product, SKU or animal.',
      openOnFocus: false,
      detachedMediaQuery: 'none',
        getSources({ query }) {
        if (!query || query.trim().length < 1) return [];

        return [
          {
            sourceId: 'products',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [{
                  indexName: CONFIG.indices.products,
                  query,
                  params: {
                    hitsPerPage:           CONFIG.hitsPerSource.products,
                    distinct:              true,
                    attributesToHighlight: ['title']
                  },
                }],
              });
            },

            getItemUrl({ item }) {
              return `/products/${item.handle}`;
            },

            templates: {
              header({ html, state }) {
                return html`
                  <div class="aa-SourceHeaderTitle">Products</div>
                  <div class="aa-SourceHeaderLine"></div>
                `;
              },

              item({ item, html, components }) {
                return SearchProductCard(item,html,components);
              },
            },
          },
          {
            sourceId: 'collections',
            async getItems() {
              const results = await getAlgoliaResults({
                searchClient,
                queries: [{
                  indexName: CONFIG.indices.collections,
                  query,
                  params: {
                    hitsPerPage:           CONFIG.hitsPerSource.collections,
                    attributesToHighlight: ['title'],
                  },
                }],
              });
              return results;
            },

            getItemUrl({ item }) {
              return `/collections/${item.handle}`;
            },

            templates: {
              header({ html }) {
                return html`
                  <div class="aa-SourceHeaderTitle">Collections</div>
                  <div class="aa-SourceHeaderLine"></div>
                `;
              },

              // Plain text name only — matches screenshot exactly
              item({ item, html, components }) {
                return html`
                  <a href="/collections/${item.handle}" class="aa-ItemLink">
                    <div class="aa-ItemWrapper">
                        <div class="aa-ItemContent">
                            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                            </div>
                            <div class="aa-ItemContentBody">
                                <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })}</div>
                            </div>
                        </div>
                    </div>
                </a>
                `;
              },
            },
          },
          {
            sourceId: 'articles',
            async getItems() {
              const results = await getAlgoliaResults({
                searchClient,
                queries: [{
                  indexName: CONFIG.indices.articles,
                  query,
                  params: {
                    hitsPerPage:           CONFIG.hitsPerSource.articles,
                    attributesToHighlight: ['title']
                  },
                }],
              });
              return results;
            },

            getItemUrl({ item }) {
              return item.url || `/blogs/${item.blog?.handle}/${item.handle}`;
            },

            templates: {
              header({ html }) {
                return html`
                  <div class="aa-SourceHeaderTitle">Articles</div>
                  <div class="aa-SourceHeaderLine"></div>
                `;
              },

              // Plain text name only — matches screenshot exactly
              item({ item, html, components }) {
                const articleUrl = item.url || `/blogs/${item.blog?.handle}/${item.handle}`;
                return html`
                    <a href="${articleUrl}" class="aa-ItemLink">
                        <div class="aa-ItemWrapper">
                            <div class="aa-ItemContent">
                                <div class="aa-ItemContentBody">
                                    <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })}</div>
                                </div>
                            </div>
                        </div>
                    </a>
                    `;
              },
            },
          },
          {
            sourceId: 'pages',
            async getItems() {
              const results = await getAlgoliaResults({
                searchClient,
                queries: [{
                  indexName: CONFIG.indices.pages,
                  query,
                  params: {
                    hitsPerPage:           CONFIG.hitsPerSource.pages,
                    attributesToHighlight: ['title']
                  },
                }],
              });
              return results;
            },

            getItemUrl({ item }) {
              return item.url || `/pages/${item.handle}`;
            },

            templates: {
              header({ html }) {
                return html`
                  <div class="aa-SourceHeaderTitle">Pages</div>
                  <div class="aa-SourceHeaderLine"></div>
                `;
              },

              // Plain text name only — matches screenshot exactly
              item({ item, html, components }) {
                const pageUrl = item.url || `/pages/${item.handle}`;
                return html`
                    <a href="${pageUrl}" class="aa-ItemLink">
                        <div class="aa-ItemWrapper">
                            <div class="aa-ItemContent">
                                <div class="aa-ItemContentBody">
                                    <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })}</div>
                                </div>
                            </div>
                        </div>
                    </a>
                    `;
              },
            },
          },
        ];
      },

      render({ elements, render, html, state }, root) {
        const { products, collections, articles, pages } = elements;
        root.classList.add('mobile-custom-autocomplete');
        render(
          html`
            <div class="maa-panel-inner">
              ${products}
              ${collections}
              ${articles}
              ${pages}
              <a
                href="${CONFIG.searchPageUrl}?q=${encodeURIComponent(state.query)}&type=product"
                class="maa-search-footer"
              >
                <span>Search for "${state.query}"</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>
            </div>
          `,
          root
        );
      },

      /* ── Submit ─────────────────────────── */
      onSubmit({ state }) {
        if (state.query.trim()) {
          window.location.href =
            `${CONFIG.searchPageUrl}?q=${encodeURIComponent(state.query)}&type=product`;
        }
      },

      /* ── Keyboard Navigation ────────────── */
      navigator: {
        navigate({ itemUrl }) {
          window.location.assign(itemUrl);
        },
        navigateNewTab({ itemUrl }) {
          window.open(itemUrl, '_blank', 'noopener');
        },
        navigateNewWindow({ itemUrl }) {
          window.open(itemUrl);
        },
      },

    }); // end autocomplete()
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForLibraries(initMobileAutocomplete));
  } else {
    waitForLibraries(initMobileAutocomplete);
  }
})();
(function initYotpoOnAlgoliaRender() {

  let _refreshTimer;
  let _isYotpoWorking = false;

  const LIST_SELECTOR = '.ais-InfiniteHits-list';

  function initNewYotpoWidgets(newNodes) {
    if (!window.yotpo || _isYotpoWorking) return;

    // Collect all un-initialised .bottomLine divs from the newly added <li>s
    const uninitialised = [];
    newNodes.forEach(node => {
      if (node.nodeType !== 1) return; // skip text nodes
      node.querySelectorAll('.yotpo.bottomLine:not([data-yotpo-initialised])')
          .forEach(el => uninitialised.push(el));
    });

    if (!uninitialised.length) return;

    try {
      _isYotpoWorking = true;
      const api = new Yotpo.API(window.yotpo);

      // refreshWidgets() will pick up the new divs since they're now in the DOM
      api.refreshWidgets();

      // Mark them so we don't double-init on next observer fire
      uninitialised.forEach(el => el.setAttribute('data-yotpo-initialised', '1'));

    } catch(e) {
      console.warn('[Yotpo] refreshWidgets error:', e);
    } finally {
      setTimeout(() => { _isYotpoWorking = false; }, 300);
    }
  }

  // ─── Observer callback ────────────────────────────────────────────────────

  function handleMutations(mutations) {
    const addedLiNodes = [];

    mutations.forEach(m => {
      if (m.type !== 'childList' || !m.addedNodes.length) return;
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) addedLiNodes.push(node);
      });
    });

    if (!addedLiNodes.length) return;

    clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(() => {
      initNewYotpoWidgets(addedLiNodes);
    }, 120);
  }

  let _observerAttached = false;

  function startObserving() {
    if (_observerAttached) return;

    const list = document.querySelector(LIST_SELECTOR);
    if (!list) {
      setTimeout(startObserving, 200);
      return;
    }

    new MutationObserver(handleMutations).observe(list, {
      childList: true,
      subtree:   false, // only direct <li> children — Yotpo's own DOM writes ignored
    });

    _observerAttached = true;
    console.log('[Yotpo+Algolia] Observer attached to', list.className);

    const existingCards = Array.from(list.querySelectorAll('li'));
    if (existingCards.length) initNewYotpoWidgets(existingCards);
  }

  // ─── Wait for Yotpo script to be ready ───────────────────────────────────

  function waitForYotpo(cb, attempts = 0) {
    if (attempts > 30) return;
    setTimeout(() => window.yotpo ? cb() : waitForYotpo(cb, attempts + 1), 100);
  }

  // ─── Boot ─────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

})();